import { Button } from 'blaze-ui/Button'
import { GoogleDrive } from 'blaze-ui/icons/20/GoogleDrive'
import { useInitiateOauthTrigger } from 'hooks/useInitiateOauthTrigger/useInitiateOauthTrigger'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { useGoogleDriveIntegration } from 'hooks/useGoogleDriveIntegration'
import { GoogleDriveActionButton } from 'components/GoogleDrive/GoogleDriveActionButton'

export const GoogleDriveImport = () => {
  const { isConnected, isSyncing, isPickerLoading, openPicker } = useGoogleDriveIntegration()
  const { connect } = useConnectAccountPopup()
  const { handleConnect } = useInitiateOauthTrigger({
    provider: ExternalIntegrationEnum.GoogleDrive,
    popUp: true,
    onInitiatedOauth: (popup?: Window) => {
      connect(popup as Window, { onConnect: openPicker })
    },
  })

  if (!isConnected) {
    return (
      <Button size="xl" aria-label="Import from Google Drive" frontIcon={GoogleDrive} onPress={handleConnect}>
        Connect Google Drive
      </Button>
    )
  }

  return (
    <GoogleDriveActionButton
      isSyncing={isSyncing}
      isPickerLoading={isPickerLoading}
      openPicker={openPicker}
      variant="primary"
      size="xl"
      frontIcon={GoogleDrive}
      label="Import More from Google Drive"
    />
  )
}
